import { render, staticRenderFns } from "./TermoDesentranhamentoRedigir.vue?vue&type=template&id=52a0df2d"
import script from "./TermoDesentranhamentoRedigir.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoRedigir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports